export default __webpack_public_path__ + "static/media/shipping-mobile-bg.1ee6af89.png";